'use strict';

var loader = require('./loader');
(function () {
  var myo = {

    /**
     * Conditional check at the beginning of each
     * recursive addNextProduct() method call
     * to ensure we don't get stuck in an 
     * infinite loop.
     */
    addAllToCart: function addAllToCart() {
      if (myo.collection.length >= 1) {
        var product = myo.collection.shift();
        myo.addNextProduct(product);
      } else {
        myo.clearCollection();
        myo.getCart();
      }
    },

    /** 
     * recursive fetch request to fit into the 
     * synchronous requirement of the Shopify
     * AJAX API. Tied to the addAllToCart() method
     */
    addNextProduct: function addNextProduct(product) {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(product)
      }).then(function (response) {
        return response.json();
      }).then(function (json) {
        myo.addAllToCart();
      }).catch(function (err) {
        alert('Uh oh! Something went wrong. Please try again.');
        console.log(err);
        myo.clearCollection;
      });
    },

    /** 
     * addToCollection() gets the product information
     * from a getProduct() call and then pushes a new
     * product object to the collection array
     */
    addToCollection: function addToCollection(handle) {
      myo.getProduct(handle).then(function (response) {
        myo.updatePrice(response.variants[0].price);
        myo.collection.push({
          quantity: 1,
          id: response.variants[0].id,
          properties: {
            'Collection': '' + document.querySelector('#myo-description h1').innerText
          }
        });
      });
    },

    /**
     * clearCollection() clears all images from 
     * the summary cell, resets the price to $0.00,
     * clears the collection array and resets the 
     * button text (for when this is called after an
     * add to cart action)
     */
    clearCollection: function clearCollection() {
      document.getElementById('price-total').innerText = '0.00';
      if (myo.collection.length > 0) {
        myo.collection = [];
      }
      document.getElementById('collection-to-cart').innerHTML = 'Add to cart';
      var checkboxes = document.getElementsByClassName('myo-checkbox');
      Array.from(checkboxes).forEach(function (element) {
        if (element.checked) {
          element.checked = false;
        }
      });
    },

    /**
     * Array for holding all products added or removed from the MYO 
     * Collection.
     */
    collection: [],

    /**
     * Triggers a fetch request to the Shopify AJAX
     * API and returns the json object of the 
     * shopping cart. Not currently used, 
     * but will need to be used to update the price
     * in the header on MYO calls.
     */
    getCart: function getCart() {
      return fetch('/cart.js', {
        method: 'GET',
        credentials: 'same-origin'
      }).then(function (response) {
        return response.json();
      }).then(function (json) {
        var cart = document.querySelector('#cart-indicator span.item-count');
        var count = json.item_count > 1 ? 'items' : 'item';
        cart.innerText = '(' + json.item_count + ')';
      });
    },

    /**
     * Triggers a fetch request to the Shopify AJAX
     * API and returns the json object of the 
     * product by its handle.
     */
    getProduct: function getProduct(handle) {
      return fetch('/products/' + handle + '.js', {
        method: 'GET',
        credentials: 'same-origin'
      }).then(function (response) {
        return response.json();
      }).catch(function (err) {
        return console.log(err);
      });
    },

    /**
     * init() initializes make your own page
     * adding event listener to section wrapper 
     * by element ID
     */
    init: function init() {
      document.addEventListener('click', function (e) {
        e.stopPropagation();
        if (e.target.dataset.handle) {
          if (e.target.checked) {
            myo.addToCollection(e.target.dataset.handle);
          } else {
            myo.removeFromCollection(e.target.dataset.handle);
          }
        } else if (e.target.id == 'collection-to-cart') {
          e.preventDefault();
          document.getElementById('collection-to-cart').innerHTML = '' + loader.svg;
          myo.addAllToCart(e);
        }
      });
    },

    /**
     * isMakeYourOwn() checks for a body 
     * data-template-type tag. Used to 
     * determine if script should be initialized.
     */
    isMakeYourOwn: function isMakeYourOwn() {
      var tempType = document.body.dataset.templateType;
      if (tempType == 'make-your-own-list') {
        return true;
      } else {
        return false;
      }
    },

    /**
     * removeFromCollection() instantiates 
     * removeImageFromSummary() to wipe the
     * image from the summary cell, then get
     * the id of the removed item and remove it from the
     * collection array.
     */
    removeFromCollection: function removeFromCollection(handle) {
      myo.getProduct(handle).then(function (response) {
        var item = myo.collection.indexOf(response.variants[0].id);
        myo.collection.splice(item, 1);
        var newPrice = -1 * response.variants[0].price;
        myo.updatePrice(newPrice);
      });
    },

    /**
     * updatePrice() checks the current price, 
     * adds (or removes depending on the price passed in)
     * that price to the current price. Price is derived from a 
     * getProduct() call.
     */
    updatePrice: function updatePrice(price) {
      var priceEl = document.getElementById('price-total');
      var currPrice = parseFloat(priceEl.innerText) * 100;
      priceEl.innerText = '' + Math.abs((currPrice + price) / 100).toFixed(2);
    }
  };

  if (myo.isMakeYourOwn()) {
    myo.init();
  }
})();